let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9jS5g"), load("i1fe2")]).then(() => parcelRequire('32Ecy'));